var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        height: "20",
        viewBox: "0 0 20 20",
        width: "20",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { fill: "#48B6E7", "fill-rule": "nonzero" } }, [
        _c("path", {
          attrs: {
            d: "M18.307 4.324l-.299.092-1.592.136-.45.69-.326-.1-1.268-1.098-.184-.571-.246-.61-.797-.686-.94-.177-.021.414.92.863.451.51-.506.255-.413-.117-.617-.248.02-.479-.81-.32-.27 1.126-.816.178.08.628 1.065.197.184-1.004.879.125.408.23h.656l.448.864 1.19 1.16-.088.45-.959-.117-1.657.804-1.193 1.376-.155.61h-.428l-.798-.354L9 9.504l.193.786.337-.374.593-.017-.041.706.49.138.491.53.802-.217.915.139 1.062.275.53.06.9.981 1.737.982-1.123 2.063-1.186.53-.45 1.178-1.715 1.101-.182.635C16.738 17.985 20 14.198 20 9.67a9.307 9.307 0 0 0-1.693-5.346z",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M10.564 15.29l-.69-1.332.634-1.374-.634-.197-.711-.744-1.576-.368-.523-1.139v.676h-.23L5.476 8.896V7.32L4.48 5.636 2.9 5.93H1.834l-.536-.365L1.982 5l-.681.164A10.111 10.111 0 0 0 0 10.135C0 15.582 4.242 20 9.475 20c.403 0 .798-.037 1.189-.086l-.099-1.195S11 16.944 11 16.884c0-.061-.436-1.594-.436-1.594zM3.432 3.548l1.782-.273.82-.494.924.292 1.476-.09.506-.871.737.133 1.79-.184.494-.597.696-.51.984.162.359-.06A9.262 9.262 0 0 0 9.732 0C6.62 0 3.837 1.556 2 4h.005l1.427-.452zm6.724-2.454L11.18.476l.657.416-.952.795-.909.1-.409-.29.589-.403zm-3.033.09l.452.207.592-.207.322.613-1.366.394-.657-.422s.642-.454.657-.585z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }